<template>
  <div class="task-comment-composer">
    <div class="task-comment-composer__field">
      <textarea
        ref="textarea"
        v-model="text"
        :placeholder="$t('Write a message…')"
        :rows="rows"
        :disabled="disabled"
        @input="autoresize"
        @keydown="onKeydown"
      />
      <span class="hint">{{ $t('Send hint') }}</span>
    </div>
    <button
      type="button"
      class="task-comment-composer__send"
      :disabled="!canSend"
      :title="$t('Send')"
      @click="emitSend"
    >
      <i class="fas fa-paper-plane" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'TaskCommentComposer',
  props: {
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { text: '', rows: 1 }
  },
  computed: {
    canSend () {
      return !this.disabled && this.text.trim().length > 0
    }
  },
  methods: {
    autoresize () {
      const ta = this.$refs.textarea
      if (!ta) return
      ta.style.height = 'auto'
      const lineHeight = 22
      const max = lineHeight * 6
      ta.style.height = Math.min(ta.scrollHeight, max) + 'px'
    },
    onKeydown (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        if (this.canSend) this.emitSend()
      }
    },
    emitSend () {
      const value = this.text.trim()
      if (!value) return
      this.$emit('send', value)
      this.text = ''
      this.$nextTick(() => this.autoresize())
    },
    focus () {
      this.$nextTick(() => this.$refs.textarea && this.$refs.textarea.focus())
    }
  }
}
</script>
